import type { ITheme } from '@visactor/vchart';
import { colorScheme } from './color-scheme';
import { token } from '../common/token';

export const arcoDesignLight: ITheme = {
  name: 'arcoDesignLight',
  description: 'Arco Design - light',
  type: 'light',
  token,
  colorScheme
};
